import React, {useContext} from 'react';
import {useNavigate} from "react-router-dom";
import {AuthContext} from "../../contexts/authContext";
import {Button} from "antd";

const GoToUserInfoButton = ({pid}) => {
    const navigate = useNavigate();
    const {currentUser} = useContext(AuthContext);

    const handleButtonClick = () => {
        const queryParams = new URLSearchParams({
            type: 'pid',
            value: pid,
            target: currentUser.target
        }).toString();
        navigate(`/player?${queryParams}`);
    };

    return (
        <Button onClick={handleButtonClick}>바로 가기</Button>
    );
};

export default GoToUserInfoButton;